module.exports = __webpack_public_path__ + "assets/img/skilled-icon.bb1fbbc8.png";